import React from "react";
import { Props } from "./types";

function AddMemberIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 51.556 42.533">
      <g>
        <g fill="none" stroke="#b9b9b9" strokeWidth="1" strokeDasharray="5">
          <circle cx="21.267" cy="21.267" r="21.267" stroke="none" />
          <circle cx="21.267" cy="21.267" r="20.767" fill="none" />
        </g>
        <g transform="translate(13.005 10.33)">
          <g transform="translate(0 0)">
            <path
              d="M11.348,10.909c2.48,0,4.494-2.445,4.494-5.454S15.179,0,11.348,0,6.86,2.445,6.86,5.454,8.868,10.909,11.348,10.909Z"
              transform="translate(-2.867)"
              fill="#b9b9b9"
            />
            <path
              d="M0,33.05Z"
              transform="translate(0 -13.811)"
              fill="#b9b9b9"
            />
            <path
              d="M29.14,33.171Z"
              transform="translate(-12.177 -13.792)"
              fill="#b9b9b9"
            />
            <path
              d="M16.957,27.15c-.087-5.239-.768-6.747-6.013-7.69a3.155,3.155,0,0,1-2.462.937,3.149,3.149,0,0,1-2.457-.937C.838,20.4.111,21.87,0,26.981v.943s1.252,2.521,8.482,2.521,8.482-2.521,8.482-2.521v-.407C16.963,27.54,16.963,27.487,16.957,27.15Z"
              transform="translate(0 -8.132)"
              fill="#b9b9b9"
            />
          </g>
        </g>
        <path
          d="M9.374,0A9.374,9.374,0,1,1,0,9.374,9.374,9.374,0,0,1,9.374,0Z"
          transform="translate(32.809 13.123)"
          fill="#232f34"
        />
        <text
          transform="translate(38 28.5)"
          fill="#fff"
          fontSize="18"
          fontFamily="Quicksand-Medium, Quicksand"
          fontWeight="500"
          letterSpacing="-0.024em"
        >
          <tspan x="0" y="0">
            +
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export { AddMemberIcon };
